import {dateTimeOptions} from '../../../settings';

export const localizedTime = function (date: number, lang?: string): string {
    return new Date(date * 1000).toLocaleTimeString(lang ? lang : navigator.language, dateTimeOptions);
};